import React, { useEffect } from "react";
import { connect } from "react-redux";
import get from "../../utils/get";
import RegisterDepartmentScreen from "../screens/RegisterDepartmentScreen";
import * as actions from "../actions/register";

const RegisterDepartmentContainer = (props) => {
  useEffect(() => {
    props.getOptions();
    // eslint-disable-next-line
  }, []);
  return <RegisterDepartmentScreen {...props} />;
};

const mapStateToProps = (state) => ({
  isLoading: get(state, "department.register.isLoading"),
  data: get(state, "department.register.data"),
});

const mapActionsToProps = { ...actions };

export default connect(
  mapStateToProps,
  mapActionsToProps
)(RegisterDepartmentContainer);
